import React from "react";
import { fechaLarga } from "@/lib/fechas";
import { hoyISO } from "@/lib/zona";
import { FRECUENCIAS, primerAviso, resumenCuando } from "@/lib/recordatorios";
import { Aviso, Campo, Opcion, Pregunta, inputCls } from "./ui";

export const pideDia = (f) => ["mensual", "trimestral", "semestral"].includes(f.frecuencia) || (f.frecuencia === "personalizada" && f.unidad === "meses");

export const validarPaso2 = (f) => {
  if (!f.frecuencia) return { campo: "frecuencia", txt: "Elige cada cuánto se repite." };
  if (f.frecuencia === "personalizada" && !(Number(f.cada_n) >= 1 && Number(f.cada_n) <= 365)) return { campo: "cada_n", txt: "Escribe un número entre 1 y 365." };
  if (pideDia(f) && !(Number(f.dia) >= 1 && Number(f.dia) <= 31)) return { campo: "dia", txt: "Escribe un día entre 1 y 31." };
  if (!f.fecha_inicio) return { campo: "inicio", txt: "Indica cuándo debe empezar." };
  if (f.fin === "fecha" && !f.fecha_fin) return { campo: "fin", txt: "Indica la fecha en la que debe terminar." };
  if (f.fin === "fecha" && f.fecha_fin < f.fecha_inicio) return { campo: "fin", txt: "La fecha de fin no puede ser anterior al inicio." };
  if (!primerAviso({ ...f, fecha_fin: f.fin === "fecha" ? f.fecha_fin : "" })) return { campo: "fin", txt: "Con estas fechas no habría ningún aviso." };
  return null;
};

const preguntaDia = (f) => (f.frecuencia === "mensual" || f.unidad === "meses" && f.frecuencia === "personalizada" ? "¿Qué día de cada mes?" : "¿Qué día del mes?");

export const PasoCuando = ({ f, set, error }) => {
  const hoy = hoyISO();
  const err = (c) => error?.campo === c && error.txt;
  return (
    <div className="space-y-5">
      <div className="space-y-3" data-testid="rp-frecuencias">
        {FRECUENCIAS.map(([id, l]) => <Opcion key={id} testid={`rp-frec-${id}`} sel={f.frecuencia === id} onClick={() => set({ frecuencia: id })} titulo={l} />)}
        {err("frecuencia") && <p className="text-sm font-semibold text-[#B91C1C]" role="alert">{error.txt}</p>}
      </div>
      {f.frecuencia === "personalizada" && (
        <Campo label="¿Cada cuánto?" error={err("cada_n")} testid="rp-campo-cada">
          <div className="flex gap-2">
            <input data-testid="rp-cada-n" type="number" inputMode="numeric" min="1" max="365" className={`${inputCls} w-28`} value={f.cada_n} onChange={(e) => set({ cada_n: e.target.value })} />
            <select data-testid="rp-unidad" className={inputCls} value={f.unidad} onChange={(e) => set({ unidad: e.target.value })}>
              <option value="dias">días</option><option value="semanas">semanas</option><option value="meses">meses</option>
            </select>
          </div>
        </Campo>
      )}
      {f.frecuencia && pideDia(f) && (
        <Campo label={preguntaDia(f)} ayuda="Si un mes no tiene ese día (por ejemplo, el 31), el aviso pasará al día 1 del mes siguiente." error={err("dia")} testid="rp-campo-dia">
          <input data-testid="rp-dia" type="number" inputMode="numeric" min="1" max="31" placeholder="Por ejemplo, 7" className={`${inputCls} w-40`} value={f.dia} onChange={(e) => set({ dia: e.target.value })} />
        </Campo>
      )}
      {f.frecuencia && (<>
        <Campo label="¿Cuándo debe empezar?" error={err("inicio")} testid="rp-campo-inicio"
          ayuda={f.frecuencia === "semanal" ? "El día de la semana será el de esta fecha." : f.frecuencia === "anual" ? "Se repetirá cada año en esta misma fecha." : undefined}>
          <input data-testid="rp-inicio" type="date" className={inputCls} value={f.fecha_inicio} onChange={(e) => set({ fecha_inicio: e.target.value })} />
          {f.fecha_inicio !== hoy && (
            <button type="button" data-testid="rp-inicio-hoy" onClick={() => set({ fecha_inicio: hoy })} className="min-h-[44px] text-base font-semibold text-[#3A6B56] underline underline-offset-4">Empezar hoy ({fechaLarga(hoy)})</button>
          )}
          {f.fecha_inicio === hoy && <p className="text-sm font-semibold text-[#92400E]" data-testid="rp-inicio-es-hoy">Has elegido empezar hoy, {fechaLarga(hoy)}.</p>}
        </Campo>
        <Pregunta>¿Cuándo debe terminar?</Pregunta>
        <div className="space-y-3">
          <Opcion testid="rp-fin-nunca" sel={f.fin === "nunca"} onClick={() => set({ fin: "nunca" })} titulo="Hasta que yo lo detenga" />
          <Opcion testid="rp-fin-fecha" sel={f.fin === "fecha"} onClick={() => set({ fin: "fecha" })} titulo="En una fecha concreta" />
        </div>
        {f.fin === "fecha" && (
          <Campo label="Fecha de fin" error={err("fin")} testid="rp-campo-fin">
            <input data-testid="rp-fecha-fin" type="date" min={f.fecha_inicio || undefined} className={inputCls} value={f.fecha_fin} onChange={(e) => set({ fecha_fin: e.target.value })} />
          </Campo>
        )}
        {f.fin !== "fecha" && err("fin") && <p className="text-sm font-semibold text-[#B91C1C]" role="alert">{error.txt}</p>}
        {!validarPaso2(f) && <Aviso testid="rp-resumen-cuando">{resumenCuando({ ...f, fecha_fin: f.fin === "fecha" ? f.fecha_fin : "" })}</Aviso>}
      </>)}
    </div>
  );
};
